/** Перенос `domain/models/update_config_model/update_config_model.dart`. */

import { z } from 'zod';

import {
  fullVersionModelSchema,
  fullVersionModelToJson,
  type FullVersionModel,
} from '@/domain/models/versionModel';

export interface UpdateConfigModel {
  readonly appUrl: string;
  readonly version: FullVersionModel;
}

/** snake_case из ответа разбирается «как есть», `transform` даёт camelCase. */
const updateConfigModelRawSchema = z.object({
  app_url: z.string(),
  version: fullVersionModelSchema,
});

export const updateConfigModelSchema = updateConfigModelRawSchema.transform(
  (raw): UpdateConfigModel => ({
    appUrl: raw.app_url,
    version: raw.version,
  }),
);

export function updateConfigModelFromJson(json: unknown): UpdateConfigModel {
  return updateConfigModelSchema.parse(json);
}

export function updateConfigModelToJson(model: UpdateConfigModel): Record<string, unknown> {
  return {
    app_url: model.appUrl,
    version: fullVersionModelToJson(model.version),
  };
}
